// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProductSearchContainer_wrapper__Ml6Uj","loader":"ProductSearchContainer_loader__6tVpM","spin":"ProductSearchContainer_spin__375wq"};